<template>
 <div class="container">

<h1><b-icon icon="person-square"></b-icon> Advisor
<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-help v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>

    <Help id="15" />



</div>
</h1>

 

<div class="row">

<div class="col-md-3 img-responsive">
        <img
          src="../../assets/advising.jpg"
          width="520"
          alt="Circle image"
          class="militray-img"
        />
      </div>
      <div class="col-md-9 pt-4">
        <div class="panal mt-20" style="margin-left: -48px">
          <div class="panal-body row pl-5">
            <h1 class="w-100">Information About Advisoring</h1>
            <p>
          The Academic Advising Center guides undeclared students from the moment they join universty until the declaration of their majors. The adviser is the first person the student meets on his or her new academic journey at universty. Advisers work hard to support undeclared students 
          in making the best possible use of the University's academic resources..

           
             
            </p>
                  <div class="text-right col-md-12 float-right"> <button class="btn btn-primary mr-2" @click="adviserMan">Your Advisor</button></div>
          </div>
        </div>
      </div>


       <div class="col-md-12 text-center mt-2">
        <div class="row">
          <div class="col-md-4 text-center p-5">
               <b-icon icon="receipt" class="spicon"></b-icon>
              <div class="option">
            <h1 class="pl-3 pr-3">Approved courses</h1>
            <p class="pl-3 pr-3">
              IF you would like to book a new course aor make your reservation of one of upcoming courses 
            </p></div>
    <button class="btn btn-primary mr-2" @click="ApprovedCourses">Enter</button>
        
            

          </div>
          
          <div class="col-md-4 text-center p-5">
               <b-icon icon="inboxes" class="spicon"></b-icon>
             
                 <div class="option">
            <h1 class="pl-3 pr-3">Show Requests </h1>
            <p class="pl-5 pr-5">
              You can Review all your Requests and see your request status 
            </p>
                 </div>
    <button class="btn btn-primary" @click="ShowRequests">Enter</button>
        
            

          </div>
            <div class="col-md-4 text-center p-5">
               <b-icon icon="tools" class="spicon"></b-icon>
             
                 <div class="option">
            <h1 class="pl-3 pr-3">AcademicPlan </h1>
            <p class="pl-3 pr-3">
              You can Review all your previous courses and Your results and see when the course start 
            </p>
                 </div>
    <button class="btn btn-primary" @click="AcademicPlan">Enter</button>
        
            

          </div>


         
        </div>


         <div class="row">
           
          <div class="col-md-4 text-center p-5">
               <b-icon icon="inbox-fill" class="spicon"></b-icon>
             
                 <div class="option">
            <h1 class="pl-3 pr-3">Advice </h1>
            <p class="pl-3 pr-3">
              You can Review all your previous courses and Your results and see when the course start 
            </p>
                 </div>
    <button class="btn btn-primary" @click="GeneralAdvice">Enter</button>
        
            

          </div>
          <div class="col-md-4 text-center p-5">
               <b-icon icon="union" class="spicon"></b-icon>
              <div class="option">
            <h1 class="pl-3 pr-3">Trial Registration </h1>
            <p class="pl-3 pr-3">
              IF you would like to book a new course aor make your reservation of one of upcoming courses 
            </p></div>
    <button class="btn btn-primary mr-2" @click="TrialRegistration">Enter</button>
        
            

          </div>
            <div class="col-md-4 text-center p-5">
               <b-icon icon="grid-fill" class="spicon"></b-icon>
             
                 <div class="option">
            <h1 class="pl-3 pr-3">Equivalent Transfer</h1>
            <p class="pl-3 pr-3">
              You can Review all your previous courses and Your results and see when the course start 
            </p>
                 </div>
    <button class="btn btn-primary" @click="EquivalentTransfer">Enter</button>
        
            

          </div>

         
        </div>
       
      </div>



<!-- 
 <div class="col-md-12" id="tabs">
<div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">AcademicPlan</a>
          <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Registration</a>
        <a v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">GeneralAdvice</a>
         <a v-on:click="activetab=4" v-bind:class="[ activetab === 4 ? 'active' : '' ]">TransferredStu</a>
        
    
    </div>

    <div class="content">
        <div v-if="activetab === 1" class="tabcontent">
          <AcademicPlan/>
        </div>
        <div v-if="activetab === 2" class="tabcontent">
          <Registration/>
        </div>

        <div v-if="activetab === 3" class="tabcontent">
          <GeneralAdvice/>
        </div>

        <div v-if="activetab === 4" class="tabcontent">
        <TransferredStu/>
        </div>
      
    </div>




  </div> -->





  <!-- <div class="col-md-3 border-right">
    <Tap/>
  </div>
  <div class="col-md-9">
    <div class="tab-content" id="v-pills-tabContent">
     <div class="tab-pane fade show active" id="v-pills-Personal" role="tabpanel" aria-labelledby="v-pills-Personal-tab"><AcademicPlan/></div>
      <div class="tab-pane fade" id="v-pills-Contact" role="tabpanel" aria-labelledby="v-pills-Contact-tab"><GeneralAdvice/></div>
      <div class="tab-pane fade" id="v-pills-Education" role="tabpanel" aria-labelledby="v-pills-Education-tab"><SendtoAdviser/></div> 
      <div class="tab-pane fade" id="v-pills-Attachments" role="tabpanel" aria-labelledby="v-pills-Attachments-tab"><TransferredStu/></div>
      <div class="tab-pane fade" id="v-pills-suggest" role="tabpanel" aria-labelledby="v-pills-suggest-tab"><Registration/></div>

    </div>
  </div> -->





</div>




</div>

</template>

<script>
// import Tap from "../../components/academic/Tap.vue";
//  import AcademicPlan from "../../components/academic/AcademicPlan.vue";
//  import GeneralAdvice from "../../components/academic/GeneralAdvice.vue";
//  import SendtoAdviser from "../../components/academic/SendtoAdviser.vue";
// import TransferredStu from "../../components/academic/TransferredStu.vue";
// import Registration from "../../components/academic/Registration.vue";

//import ApplicantService from '../services/Applicant/Applicant.service'
//import ApplicantService from '../../services/Applicant/Applicant.service';
import Help from '../Help.vue';


export default {
   components: {
      Help
    //  AcademicPlan,GeneralAdvice,TransferredStu,Registration,
  
  },
  data () {
    return {
      el: '#tabs',
      activetab: 1,
      info: '',
  
    }
  },

   methods: {
    adviserMan() {
     
      this.$router.push("/YourAdvisor");
    },
   ApprovedCourses() {
     
      this.$router.push("/ApprovedCourses");
    },
      AcademicPlan() {
     
      this.$router.push("/AcademicPlan");
    },
      GeneralAdvice() {
     
      this.$router.push("/GeneralAdvice");
    },
      TrialRegistration() {
     
      this.$router.push("/TrialRegistration");
    },
      EquivalentTransfer() {
     
      this.$router.push("/EquivalentTransfer");
    },
      ShowRequests() {
     
      this.$router.push("/ShowRequest");
    },
   },

 
  computed:{
    reviewApplication(){
       return  this.$store.state.auth.renderReview 

        
       }
  },
   mounted() {

 
}
}


</script>

<style scoped>
.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
}
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#ff8600;
}
.modal-footer {
    background: #f6f6f6 !important;
}

.panal{
  background:rgb(255, 255, 255);
  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}


/* Style the tabs */
.tabs {
    overflow: hidden;
  margin-left: 20px;
    margin-bottom: -2px; 
}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    cursor: pointer;
    padding: 12px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #285475;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
     color: #fff;
}
.tabs a:last-child { 
    border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #aaa;
    color: #fff;
}

/* Styling for active tab */
.tabs a.active {
   background-color: #fff;
    color: #285475;
    border-bottom: 2px solid #fff;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}


@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
.militray-img{
  width : 75vw !important
}
.panal{
  margin-left: 0px !important;
}
.option .pl-5{
  padding: 2px;
}
}
.spicon{
   color: #ff8600;
   font-size: 45px;
   font-weight: 800;

}

</style>
